










import { Component, Vue, Ref } from 'vue-property-decorator';
import PaycheckLineTemplateForm from '@/components/PaycheckLineTemplate/PaycheckLineTemplateForm.vue';
import i18n from '@/i18n';
import { UnsavedChanges } from '@/decorators/unsaved-changes';

@Component({
  components: {
    PaycheckLineTemplateForm,
  },
})
export default class PaycheckLineTemplate extends Vue {
  @Ref('paycheckLineTemplateForm') private readonly form!: PaycheckLineTemplateForm;
  @UnsavedChanges<PaycheckLineTemplate>({
    messages: {
      // i18n.t used instead of this.$t because function is async and component calling it might be destroyed, making 'this' undefined
      entity: i18n.t('PaycheckLineTemplate.name'),
    },
    saveAndContinue() {
      return this.form && this.form.saveAndContinue();
    },
  }) private dirtyForm = false;
}
